/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconDelete from 'DesignSystem/Svgs/TysiaIconDelete/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/Notes/Note/DeleteAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content/Content'))}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconDelete
{...childProps}
  viewPath={`${viewPath}/TysiaIconDelete`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}